import { EntityId } from "@jackfruit/common"
import { useCallback, useState } from "react"
import { useProcessActions } from "~/hooks/useProcessActions"
import { wait } from "~/services/Utils"
import { CloudImage } from "../CloudProviderTypes"
import { useCloudProviderContext } from "./useCloudProviderContext"

export const useCloudProviderActions = () => {
  const {
    setIsImportingImages,
    isImportingImages,
    closeCloudProviderModal,
    imageRegionId,
    lineItemId,
    productId,
  } = useCloudProviderContext()

  const [selectedImageIds, setSelectedImageIds] = useState<EntityId[]>([])
  const process = useProcessActions()

  const hasSelectedImages = selectedImageIds.length > 0

  const handleImageSelect = useCallback((id: EntityId) => {
    setSelectedImageIds(prev => {
      if (prev.find(selectedId => selectedId === id)) {
        return prev.filter(selectedId => selectedId !== id)
      } else {
        return [...prev, id]
      }
    })
  }, [])

  const handleUploadImages = async (images: CloudImage[]) => {
    setIsImportingImages(true)
    if (lineItemId) {
      const imageUrls = images.map(image => image.url)
      process.fillLineItemImageRegionsWithImageUrls({
        lineItemId,
        imageRegionId: imageRegionId ?? undefined,
        imageUrls,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    } else {
      const imageUrls = images.map(image => image.url)
      process.createLineItemForProductIdWithImageUrl({
        productId: productId ?? undefined,
        imageUrls,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    }
  }

  return {
    selectedImageIds,
    hasSelectedImages,
    isImportingImages,
    handleImageSelect,
    handleUploadImages,
    closeCloudProviderModal,
  }
}
